/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from 'eui-components';

const NotFoundView = props => {
  const goBack = (e) => {
    e.preventDefault();
    props.history.goBack(e);
  };

  const refresh = (e) => {
    e.preventDefault();
    props.history.push();
  };

  return (
    <div align="center">
      <h3><FormattedMessage id="NotFoundView.heading" defaultMessage="Oops. Something went wrong."/></h3>
      <h4>
        <FormattedMessage id="NotFoundView.content"
          defaultMessage="We can't seem to display the page you're looking for, or it does not exist."/>
      </h4>
      <p>{props.location && props.location.pathname}</p>
      <span>
        <Button type="button" onClick={refresh}>
          <FormattedMessage id="NotFoundView.tryAgainButtonLabel" defaultMessage="Try again"/>
        </Button>
        <Button type="button" onClick={goBack}>
          <FormattedMessage id="NotFoundView.returnButtonLabel" defaultMessage="Return to previous screen"/>
        </Button>
      </span>
    </div>
  );
};

NotFoundView.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func
  })
};

export default injectIntl(NotFoundView);



// WEBPACK FOOTER //
// ./src/NotFoundView/NotFoundView.js